import { Auth } from '@ax/auth';
import { Navigate, Outlet } from 'react-router-dom';
import SecurityProvider from '@/modules/Security';
import { selectIsProviderAdmin, useAppSelector } from '@ax/redux-store';
import { routerPaths } from '@ax/constants';

const PrivateRoute = () => {
  const isAdmin = useAppSelector(selectIsProviderAdmin);

  if (isAdmin) {
    return (
      <Navigate
        to={routerPaths.adminNotes}
        replace
      />
    );
  }

  return Auth.isLoggedIn() ? (
    <SecurityProvider>
      <Outlet />
    </SecurityProvider>
  ) : (
    <Navigate
      to="/"
      replace
    />
  );
};

export default PrivateRoute;
